import { createBrowserHistory } from 'history'
export const history = createBrowserHistory()

export function authHeader() {
    try {
        const pathname = window.location.pathname || "";

        const publicPaths = new Set([
            '/auth/login',
            '/confirmToken',
            '/resetPassword',
            '/confirmRegistration',
            '/register',
        ]);

        if (publicPaths.has(pathname)) return {};

        const token = localStorage.getItem('token');
        const user = JSON.parse(localStorage.getItem('user') || 'null');

        if (token && (user || pathname === '/profile')) {
            return { Authorization: `Bearer ${token}` };
        }

        return {};
    } catch (error) {
        console.error('Erro ao gerar authHeader:', error);
        return {};
    }
}
